<template>
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="img">
          <img src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1606543962033_img_banner_fd.png" />
        </div>
        <section>
          <div class="titArea">
            <p class="titH4">웰몰의 상품을 추천하세요.</p>
          </div>

          <ul class="prdList line bbNone">
            <li v-for="(product, index) in productList" :key="index">
              <div class="block">
                <div class="prdItem full">
                  <div class="imgArea">
                    <div class="badgeArea">
                      <span class="badge" v-for="(topTags, topTagsIndex) in product.tagInfos.topTags" :key="topTagsIndex">
                        <img :src="topTags.imgPath" />
                      </span>
                    </div>
                    <!-- <span class="img"><img src="@/../static/img/mw/temp/temp_product03.png" alt="NEW 웰릭스 음식물처리기 DK-W2020" /></span> -->
                    <span
                      class="img imgCover"
                      @click="
                        product.productIndex != '0' && product.discntFlag != 'Y'
                          ? $router.push('/product/category/detail/' + product.productIndex)
                          : ''
                      "
                    >
                      <img :src="product.thumbnail" alt="" />
                    </span>
                  </div>
                  <div class="infoArea">
                    <div
                      class="tit row2"
                      @click="
                        product.productIndex != '0' && product.discntFlag != 'Y'
                          ? $router.push('/product/category/detail/' + product.productIndex)
                          : ''
                      "
                    >
                      <span>{{ product.displayName }}</span>
                    </div>
                    <div class="txtItem">
                      <span>{{ product.model }}</span>
                    </div>
                    <div class="hashtag">
                      <span
                        v-for="(bottomTags, bottomTagsIndex) in product.tagInfos.bottomTags"
                        :key="bottomTagsIndex"
                        v-text="bottomTags.tagName"
                      ></span>
                    </div>
                    <div class="price">
                      <span class="money del">
                        월
                        <span>{{ product.rentalAmount | currency }}</span>
                        원
                      </span>
                      <br />
                      <span class="money pointC1">
                        월
                        <em>{{ product.cardDCrentalAmount | currency }}</em>
                        원
                        <i>/제휴카드가</i>
                      </span>
                    </div>

                    <ul class="utilBtn">
                      <li>
                        <a @click="updateWishList(product)" class="icoBtn zzim" :class="{ on: product.wishItem }">
                          <span>
                            찜 (
                            <i>{{ product.wishCount }}</i>
                            )
                          </span>
                        </a>
                        <!-- 클래스 on -->
                      </li>
                    </ul>
                  </div>
                </div>
                <!--<a href="javascript:void(0);" class="fr txtXS tit link" @click="showRecommendBenefits">혜택 보기</a>-->
                <p class="txtIco_bubb bold" @click="showRecommendBenefits">추천 시 혜택 보기</p>

                <div class="btnArea two half">
                  <!-- <button type="button" class="btn_s m" @click="linkCopy(product.productIndex)">링크 복사하기</button>
                  <button type="button" class="btn_p m" @click="friendRecommend(product)">친구 추천하기</button> -->
                  <button type="button" class="btn_s m" @click="goNextStep('copy', product)">링크 복사하기</button>
                  <button type="button" class="btn_p m" @click="goNextStep('recommend', product)">친구 추천하기</button>
                </div>
              </div>
            </li>
          </ul>
        </section>
        <section class="hr">
          <div class="titArea mt0">
            <p class="titH4">유의사항</p>
          </div>
          <ul class="txtList_remark">
            <li>혜택은 소개 받은 사람이 제품 설치 후, 14일 이후 제공됩니다.</li>
            <li>소개인에 제공되는 혜택은 세금신고 목적으로 주민번호 수집이 필요합니다. (별도 문자 안내 예정)</li>
            <li>중도해지 시 할인된 렌탈료는 위약금에 추가됩니다.</li>
            <li>1인당 소개 건 제한은 없습니다. (2명 소개 시, 4개월 감면)</li>
            <li>
              소개인의 혜택은 이용상품에 따라 다르게 지급됩니다.
              <br />
              ('추천 시 혜택' 표 참고)
            </li>
          </ul>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>

    <MessagePop v-if="messagePop" @close="messagePop = false"><p v-html="msg"></p></MessagePop>
    <ConfirmPop v-if="confirmPop" @confirm="confirm" @cancel="confirmPop = false" @close="confirmPop = false">
      <p v-html="msg"></p>
    </ConfirmPop>
    <UpdateWishList ref="wish" @updateWishCount="updateWishCount"></UpdateWishList>
    <FriendRecommendBenefits v-if="friendRecommendBenefitsPop" @close="friendBenefitClose" />
    <FriendRecommendPop
      v-if="friendRecommendPop"
      :rentalList="rentalList"
      @select="selectProduct"
      @close="friendRecommendPop = false"
    ></FriendRecommendPop>
  </div>
</template>

<script>
import MessagePop from '@/components/popup/MessagePop';
import ConfirmPop from '@/components/popup/ConfirmPop';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import UpdateWishList from '@/components/comm/UpdateWishList';
import FriendRecommendBenefits from '@/views/app/mypage/friend/FriendRecommendBenefits';
import FriendRecommendPop from '@/views/app/mypage/friend/FriendRecommendPop';
import { LOGIN_REQUIRE } from '@/store/message.type.js';

const baseUrl = process.env.VUE_APP_BASE_URL;
const deepLinkURL = process.env.VUE_APP_DEEP_LINK_URL;

export default {
  name: 'FriendRecom',
  components: { UpdateWishList, FriendRecommendBenefits, MessagePop, ConfirmPop, FriendRecommendPop },
  mounted() {
    ApiService.service('GET', '/product/recommend/freind')
      .then(({ data }) => {
        console.log(data);
        this.productList = data.result;
      })
      .catch(({ response }) => {
        console.log(response);
      });
    /*
    if (JwtService.getToken()) {
      ApiService.service('GET', '/user/auth/recommendcode')
        .then(({ data }) => {
          console.log(data);
        })
        .catch(({ response }) => {
          console.log(response);
        });
    }
    */
  },
  data: function () {
    return {
      headerTitle: '친구 추천',
      recommendCode: '',
      productList: [], // 친구추천 상품 리스트
      product: Object, // 친구추천 상품 인덱스
      msg: '',
      messagePop: false,
      confirmPop: false,
      friendRecommendBenefitsPop: false,
      friendRecommendPop: false,
      rentalList: [],
      flag: String,
    };
  },
  methods: {
    linkCopy(rmanCd) {
      // this.login();
      const url =
        deepLinkURL + baseUrl + 'friendRecommendRecv/' + rmanCd + '/' + this.product.productIndex + '&af_force_deeplink=true&af_dp=welmall://';
      console.log(url);
      window.copy(url);
    },
    friendRecommend(rmanCd) {
      // this.login();
      const url = deepLinkURL + baseUrl + 'friendRecommendRecv/' + rmanCd + '/' + this.product.productIndex;

      let templateId = 40277;
      let obj = {
        price: this.product.rentalAmount + '',
        img: this.product.thumbnail,
        salePrice: (this.product.rentalAmount * 1 - 13000 > 0 ? this.product.rentalAmount * 1 - 13000 : 0) + '',
        productName: this.product.productName,
        productTitle: '나도, 친구도 1+1 더블혜택',
        productIndex: this.product.productIndex + '',
        friendCode: rmanCd,
        path: baseUrl + 'friendRecommendRecv/' + rmanCd + '/' + this.product.productIndex,
      };

      const templateArgs = JSON.stringify(obj);

      // 앱
      if (navigator.userAgent.match(/RIX/i)) {
        console.log('app');
        window.share(url, templateId, templateArgs);
      } else {
        // 모바일 웹
        console.log('mobileWeb');
        if (navigator.share) {
          navigator
            .share({ title: '웰릭스렌탈', text: this.product.displayName, url: url + '&af_force_deeplink=true&af_dp=welmall://' })
            .then(() => console.log('공유완료'))
            .catch((err) => console.log('공유실패] ', err));
        } else {
          alert('지원하지 않는 브라우저입니다.');
        }
      }
    },
    updateWishList(product) {
      this.$refs.wish.updateWishList(product);
    },
    updateWishCount(product, flag, count) {
      product.wishItem = flag;
      product.wishCount += count;
    },
    showRecommendBenefits() {
      this.friendRecommendBenefitsPop = true;
    },
    friendBenefitClose() {
      this.friendRecommendBenefitsPop = false;
    },
    async goNextStep(flag, product) {
      this.flag = flag; // 버튼 구분
      this.product = product;

      if (!JwtService.getToken()) {
        // 로그인 유무 체크
        this.msg = LOGIN_REQUIRE;
        this.confirmPop = true;
        return;
      } else {
        await ApiService.service('GET', '/order/auth/myRentalList')
          .then(({ data }) => {
            console.log(data);
            this.rentalList = data.result;
          })
          .catch(({ response }) => {
            console.log(response);
          });

        if (this.rentalList.length == 0) {
          this.msg = `이용중인 렌탈 상품이 없습니다.<br/>렌탈 이용 시, 혜택을 받아보실 수 있습니다.`;
          this.messagePop = true;
        } else {
          this.friendRecommendPop = true;
        }
      }
    },
    confirm() {
      this.$router.push({ name: 'login', params: { redirect: this.$route.name } });
    },
    selectProduct(product) {
      console.log(product);
      this.friendRecommendPop = false;
      if (this.flag == 'copy') {
        this.linkCopy(product.rmanCd);
      } else {
        this.friendRecommend(product.rmanCd);
      }
    },
  },
};
</script>
